import { Navigate, Route, Routes } from 'react-router-dom';
import { DataProvider } from './data.js';
import { AdminDashboard } from './pages/AdminDashboard.js';
import { EditorPage } from './pages/EditorPage.js';
import { NewProspectPage } from './pages/NewProspectPage.js';
import { ProposalPage } from './pages/ProposalPage.js';
import { ProspectSettingsPage } from './pages/ProspectSettingsPage.js';
import { PublicSitePage } from './pages/PublicSitePage.js';

export function App() {
  return (
    <DataProvider>
      <Routes>
        <Route path="/" element={<Navigate to="/admin" replace />} />
        <Route path="/sites/:slug" element={<ProposalPage />} />
        <Route path="/p/:slug" element={<ProposalPage />} />
        <Route path="/site/:slug" element={<PublicSitePage />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin/prospects/new" element={<NewProspectPage />} />
        <Route path="/admin/prospects/:slug/settings" element={<ProspectSettingsPage />} />
        <Route path="/admin/websites/:slug/edit" element={<EditorPage />} />
        <Route path="*" element={<Navigate to="/admin" replace />} />
      </Routes>
    </DataProvider>
  );
}
